/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from "react-redux";

import { confirmDialog } from 'primereact/confirmdialog';

import Header from '@components/Header';
import LoadingAction from '@components/LoadingAction';
import General from '@components/DigitalForm/General';
import JustificationModal from '@components/JustificationModal';

import { getDetailDigitalForm, updateDigitalForm, updateStatusDigitalForm } from '@actions/digitalForms';
import { sendActionToBitacora  } from '@actions/bitacora';

import { CLEAR_VALUES_DIGITAL_FORM } from '@constants/actionType'
import { AuthorizedStatusSend } from '@constants/general'


const DigitalFormEdit = ({history}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [ loadingPage, setLoadingPage ] = useState(true)
  const [ btnSubmitLoading, setBtnSubmitLoading ] = useState(false)
  const [ showModalJustification, setShowModalJustification ] = useState({isVisible: false})

  const _idFormulario = useSelector(state => state.digitalForm.idFormulario);
  const _general = useSelector(state => state.digitalForm.general);

  const loadVersion = async (version) => {
    setLoadingPage(true)
    await dispatch(getDetailDigitalForm({id: version}));

    setLoadingPage(false)
  }

  useEffect(async () => {
    // await getDetailSurveys({id: history.location.state.id})
    if (!history.location.state?.defaultVersionId) return history.push('/digital-form')
    if (history.location.state?.clearCache) {
      await dispatch({
        type: CLEAR_VALUES_DIGITAL_FORM,
      })
    }

    loadVersion(history.location.state.defaultVersionId)

  }, [])

  const editEmail = async (justification, sendComment = true) => {
    setBtnSubmitLoading(true)
    const response = await dispatch(updateDigitalForm());
    if (!response.status) {
      setBtnSubmitLoading(false)
      if (sendComment) {
        const dataBitacora = {
          transactionName: 'actFormularioDigital',
          reason: `${_general.nombre} || ${justification}`,
        }
        await dispatch(sendActionToBitacora(dataBitacora))
        return confirmDialog({
          message: t('La operación se ha realizado de manera éxitosa'),
          header: t('Confirmación'),
          icon: 'pi pi-check-circle',
          acceptLabel: t('Continuar'),
          rejectClassName: 'hide-component',
          accept: () => history.push('/digital-form'),
          onHide: () => history.push('/digital-form')
        });
      }
    }
    setBtnSubmitLoading(false)
    return response
  }

  const onChangeVersion = (newVersion) => {
    loadVersion(newVersion)
  }

  const saveAndSendAuthorized = async (justification) => {
    const sendComment = false
    const responseEdit = await editEmail("", sendComment)
    if (!responseEdit.status) {
      const response = await dispatch(updateStatusDigitalForm({id: _idFormulario, status: AuthorizedStatusSend.STATUS_PENDING}));
      if(!response.status) {
        const dataBitacora = {
          transactionName: 'envAutFormularioDigital',
          reason: `${_general.nombre} || ${justification}`,
        }
        await dispatch(sendActionToBitacora(dataBitacora))
        return confirmDialog({
          message: t('La operación se ha realizado de manera éxitosa'),
          header: t('Confirmación'),
          icon: 'pi pi-check-circle',
          acceptLabel: t('Continuar'),
          rejectClassName: 'hide-component',
          accept: () => history.push('/digital-form'),
          onHide: () => history.push('/digital-form')
        });
      }
    }
  }
  
  const saveAndAutorized = async (justification) => {
    const sendComment = false
    const responseEdit = await editEmail("", sendComment)
    if (!responseEdit.status) {
      const response = await dispatch(updateStatusDigitalForm({id: _idFormulario, status: AuthorizedStatusSend.STATUS_AUTHORIZED}));
      if(!response.status) {
        const dataBitacora = {
          transactionName: 'autFormularioDigital',
          reason: `${_general.nombre} || ${justification}`,
        }
        await dispatch(sendActionToBitacora(dataBitacora))
        return confirmDialog({
          message: t('La operación se ha realizado de manera éxitosa'),
          header: t('Confirmación'),
          icon: 'pi pi-check-circle',
          acceptLabel: t('Continuar'),
          rejectClassName: 'hide-component',
          accept: () => history.push('/digital-form'),
          onHide: () => history.push('/digital-form')
        });
      }
    }
  }

  
  const onConfirmReject = () => {
    setShowModalJustification({
      isVisible: true,
      title: t('Rechazar formulario digital'),
      descriptionAlt: t("Rachazar esta versión, provocara que se elimine de forma difinitiva la versión"),
      label: t('Justificacion de rechazo'),
      continueAction: ({justification}) => onReject(justification),
    });
  }

  const onReject = async (justification) => {
    const response = await dispatch(updateStatusDigitalForm({id: _idFormulario, status: AuthorizedStatusSend.STATUS_REJECTED}));
    if(!response.status) {
      const dataBitacora = {
        transactionName: 'rechazoFormularioDigital',
        reason: `${_general.nombre} || ${justification}`,
      }
      await dispatch(sendActionToBitacora(dataBitacora))
      return confirmDialog({
        message: t('La operación se ha realizado de manera éxitosa'),
        header: t('Confirmación'),
        icon: 'pi pi-check-circle',
        acceptLabel: t('Continuar'),
        rejectClassName: 'hide-component',
        accept: () => history.push('/digital-form'),
        onHide: () => history.push('/digital-form')
      });
    }
  }

  if (loadingPage) return <LoadingAction/>

  return (
    <div className="p-grid p-justify-center">
      <div className="p-col-12">
        <Header title={t('Procesos Digitales')} linkText={t("Ir al listado")} to="/digital-form" />
        <p>{t('Cambia los textos en los diferente multi-idiomas existentes')}</p>
      </div>

      <div className="p-col-12 p-mt-2">
        <div className="card">
          <div className="p-grid p-mb-2">
            <div className="p-col-12 p-my-1">
              <General
                btnSubmitLoading={btnSubmitLoading}
                changeVersion={onChangeVersion}
                isEdit
                success={editEmail}
                authorize={saveAndAutorized}
                sendAuthorize={saveAndSendAuthorized}
                reject={onConfirmReject}
              />
            </div>
          </div>
        </div>
      </div>
      <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          descriptionAlt={showModalJustification.descriptionAlt}
          label={showModalJustification.label}
          btnOkLabel={showModalJustification.btnOkLabel}
          onHidden={() => setShowModalJustification({isVisible: false})}
          onContinueAction={showModalJustification.continueAction}
        />
    </div>
  );

}
export default DigitalFormEdit;